import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonService } from './services/common.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from './services/auth.service';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidebarModule } from 'primeng/sidebar';

import { Auth } from '@angular/fire/auth';
import { signOut } from '@angular/fire/auth';

import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MatChipsModule } from '@angular/material/chips';
import { filter, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    SidebarModule,
    ToastModule,
    ConfirmDialogModule,
    MatChipsModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ConfirmationService],
})
export class AppComponent {
  public titleString$: Observable<string> = of('Welcome');
  public sidebarVisible: boolean = false;
  private readonly auth: Auth = inject(Auth);
  public readonly commonService: CommonService = inject(CommonService);
  public readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  public sidebarMenuItems: any[] = [];
  public user_name: string = 'Agent';
  public readonly avatarIcon: string =
    'https://www.shareicon.net/data/512x512/2016/09/15/829453_user_512x512.png';
  constructor(private readonly confirmationService: ConfirmationService) {
    this._buildSidebar();
    this.titleString$ = this.authService.idToken.pipe(
      filter((user) => !!user),
      map((user) => (user ? `Hi, ${user.displayName}` : 'Welcome'))
    );
  }

  public onLogoutClick(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure that you want to logout?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.commonService.showLoader();
        signOut(this.auth)
          .then(() => this.router.navigate(['/login']))
          .catch((error) => {
            console.log('Error on signout : ', error);
            const s = 'error';
            const title = 'Error';
            const msg = 'Failed to sign out!';
            this.commonService.showMsg(s, title, msg);
          })
          .finally(() => this.commonService.hideLoader());
      },
      reject: () => null,
    });
  }

  private _buildSidebar() {
    this.sidebarMenuItems = [
      {
        label: 'Dashboard',
        icon: 'dashboard',
        func: () => {
          this.router.navigate(['/dashboard']);
        },
      },
      {
        label: 'Delivery Manager',
        icon: 'delivery_dining',
        func: () => {
          this.router.navigate(['/delivery-manager']);
        },
      },
      {
        label: 'Menu items',
        icon: 'lunch_dining',
        func: () => {
          this.router.navigate(['/menu-items']);
        },
      },
      {
        label: 'Profile',
        icon: 'person',
        func: () => {
          this.router.navigate(['/profile']);
        },
      },
    ];
  }

  public onActivate($event: any) {
    this.commonService.makePageLoaded();
  }
}
